var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoFullscreen = function SvgIcoFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M22 10V2.997a1 1 0 0 0-.29-.702l-.005-.004A1 1 0 0 0 21 2h-7a1 1 0 1 0 0 2h4.586l-5.293 5.293a1 1 0 0 0 1.414 1.414L20 5.414V10a1 1 0 1 0 2 0M4 14a1 1 0 1 0-2 0v7a1 1 0 0 0 .29.705l.005.004c.18.18.428.29.702.291H10a1 1 0 1 0 0-2H5.414l5.293-5.293a1 1 0 0 0-1.414-1.414L4 18.586z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoFullscreen;